import React, { useState } from 'react';
import {
  Avatar,
  Box,
  Menu,
  MenuItem,
  Typography,
  IconButton,
  Divider
} from '@mui/material';
import { AccountCircle, Logout, Settings } from '@mui/icons-material';
import { useAuth } from './AuthContext';

const ProfileBubble = () => {
  const { user, logout, projectKey } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleMenuClose();
  };

  if (!user) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <IconButton
        onClick={handleMenuOpen}
        sx={{ 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '32px',
          width: '32px',
          padding: 0
        }}
        size="small"
      >
        {user.picture ? (
          <Avatar
            src={user.picture}
            alt={user.name || user.email}
            sx={{ width: 28, height: 28 }}
          />
        ) : (
          <AccountCircle sx={{ fontSize: 28 }} />
        )}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            minWidth: 200,
            mt: 1,
          }
        }}
      >
        <MenuItem sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            {user.name || user.email}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {user.email}
          </Typography>
          <Typography variant="caption" color="primary">
            Project: {projectKey || 'none'}
          </Typography>
        </MenuItem>
        
        <Divider />
        
        <MenuItem onClick={() => {
          window.location.href = projectKey ? `/${projectKey}/settings` : '/settings';
          handleMenuClose();
        }}>
          <Settings sx={{ mr: 1, fontSize: 20 }} />
          Settings
        </MenuItem>
        
        <MenuItem onClick={handleLogout}>
          <Logout sx={{ mr: 1, fontSize: 20 }} />
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ProfileBubble; 